import React from 'react';
import { RouteComponentProps, Switch, Route } from 'react-router-dom';
import { SearchSurveysPage } from './pages';

export function SurveysRoutes({ match }: RouteComponentProps) {
  return (
    <Switch>
      <Route path={match.path} component={SearchSurveysPage} />
    </Switch>
  );
}
